import { useLayoutEffect } from "react";

const LOADING_TITLE = "جاري التحميل…";

function resolveLogoUrl(logoUrl) {
  if (!logoUrl || logoUrl.length <= 4) {
    return "";
  }

  if (logoUrl.startsWith("http://") || logoUrl.startsWith("https://")) {
    return logoUrl;
  }

  return `${process.env.REACT_APP_BACKEND_URL}${logoUrl}`;
}

export default function useRestaurantBrowserIdentity(restaurant) {
  const restaurantId = restaurant?.id || restaurant?.slug || restaurant?.name;
  const restaurantName = restaurant?.name;
  const restaurantSlug = restaurant?.slug;
  const logoUrl = restaurant?.logo_url;

  useLayoutEffect(() => {
    const previousTitle = document.title;

    if (!restaurantId || !restaurantName) {
      document.title = LOADING_TITLE;

      return () => {
        if (document.title === LOADING_TITLE) {
          document.title = previousTitle;
        }
      };
    }

    const faviconUrl = resolveLogoUrl(logoUrl);
    const currentFavicon = document.head.querySelector("link[rel~='icon']");
    const favicon = faviconUrl ? currentFavicon || document.createElement("link") : null;
    const createdFavicon = Boolean(favicon && !currentFavicon);
    const previousHref = favicon?.getAttribute("href");
    const previousRel = favicon?.getAttribute("rel");
    const previousRestaurantId = favicon?.getAttribute("data-restaurant-favicon");
    const currentManifest = document.head.querySelector("link[rel='manifest']");
    const manifest = restaurantSlug ? currentManifest || document.createElement("link") : null;
    const createdManifest = Boolean(manifest && !currentManifest);
    const previousManifestHref = manifest?.getAttribute("href");
    const previousManifestRestaurantId = manifest?.getAttribute("data-restaurant-manifest");

    document.title = restaurantName;

    if (favicon) {
      favicon.setAttribute("rel", "icon");
      favicon.setAttribute("href", faviconUrl);
      favicon.setAttribute("data-restaurant-favicon", restaurantId);

      if (createdFavicon) {
        document.head.appendChild(favicon);
      }
    }

    if (manifest) {
      manifest.setAttribute("rel", "manifest");
      manifest.setAttribute(
        "href",
        `/api/public/restaurants/${encodeURIComponent(restaurantSlug)}/manifest.webmanifest`,
      );
      manifest.setAttribute("data-restaurant-manifest", restaurantId);

      if (createdManifest) {
        document.head.appendChild(manifest);
      }
    }

    return () => {
      if (document.title === restaurantName) {
        document.title = previousTitle;
      }

      if (favicon && favicon.getAttribute("data-restaurant-favicon") === restaurantId) {
        if (createdFavicon) {
          favicon.remove();
        } else {
          if (previousHref === null) {
            favicon.removeAttribute("href");
          } else {
            favicon.setAttribute("href", previousHref);
          }

          if (previousRel === null) {
            favicon.removeAttribute("rel");
          } else {
            favicon.setAttribute("rel", previousRel);
          }

          if (previousRestaurantId === null) {
            favicon.removeAttribute("data-restaurant-favicon");
          } else {
            favicon.setAttribute("data-restaurant-favicon", previousRestaurantId);
          }
        }
      }

      if (!manifest || manifest.getAttribute("data-restaurant-manifest") !== restaurantId) {
        return;
      }

      if (createdManifest) {
        manifest.remove();
        return;
      }

      if (previousManifestHref === null) {
        manifest.removeAttribute("href");
      } else {
        manifest.setAttribute("href", previousManifestHref);
      }

      if (previousManifestRestaurantId === null) {
        manifest.removeAttribute("data-restaurant-manifest");
      } else {
        manifest.setAttribute("data-restaurant-manifest", previousManifestRestaurantId);
      }
    };
  }, [logoUrl, restaurantId, restaurantName, restaurantSlug]);
}